import { PlayerListItemFragment, UnionFragment } from '@amf/shared/types/graphql';
import { useTranslate } from '@tolgee/react';
import usePlayerUnions from '@amf/shared/data/hooks/usePlayerUnions';
import { getPlatformLink, getUnionContent } from '@amf/shared/data/Union';

interface PlayerUnionItemProps {
  union: UnionFragment;
}

function PlayerUnionItem({ union }: PlayerUnionItemProps) {
  const content = getUnionContent(union.id);
  return (
    <div className='PlayerUnions__item'>
      <div className='PlayerUnions__logo'>{content?.logo}</div>
      <div className='PlayerUnions__content'>
        <h3>{union.name}</h3>
        <p>{union.domain}</p>
      </div>
    </div>
  );
}

interface PlayerUnionsProps {
  player: PlayerListItemFragment;
}

function PlayerUnions({ player }: PlayerUnionsProps) {
  const { t } = useTranslate();
  const { unions } = usePlayerUnions(player.id);
  if (unions.length === 0) return null;
  return (
    <div className='PlayerUnions'>
      <h2>{t('player.unions.title')}</h2>
      <div className='PlayerUnions__grid'>
        {unions.map(union => {
          const link = getPlatformLink(union, `hrac/${player.id}`);
          if (link) {
            return (
              <a href={link.toString()} target='_blank' rel='noreferrer' key={union.id}>
                <PlayerUnionItem union={union} />
              </a>
            );
          }

          return <PlayerUnionItem key={union.id} union={union} />;
        })}
      </div>
    </div>
  );
}

export default PlayerUnions;
